module.exports = __webpack_public_path__ + "img/total-blue.1fe9005b.svg";